<edge-app-features [features]="features"></edge-app-features>